var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharmDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.25C12.75 5.25 8.25 11.25 8.25 11.25V24.75V36.75C8.25 36.75 12.75 42.75 24 42.75C35.25 42.75 39.75 36.75 39.75 36.75V24.75V11.25C39.75 11.25 35.25 5.25 24 5.25Z",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#02355A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 24.75C8.25 24.75 12.75 30.75 24 30.75C35.25 30.75 39.75 24.75 39.75 24.75M8.25 12.75C8.25 12.75 12.75 18.75 24 18.75C35.25 18.75 39.75 12.75 39.75 12.75",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#02355A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmDatabase);
export default __webpack_public_path__ + "static/media/charm_database.2beb5c69eb38c532bfbf8abd4c906c02.svg";
export { ForwardRef as ReactComponent };